import QuoteModal from "@components/QuoteModal/QuoteModal";
import { useState } from "react";
import { A11y, Keyboard, Navigation, Pagination } from "swiper/modules";
import { Swiper as Slider, SwiperSlide } from "swiper/react";
import "swiper/scss";
import "swiper/scss/a11y";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import styles from "./C27_NavigationalQuote.module.scss";
import { Quote, QuoteType } from "./C27_Quote";

export interface NavigationalQuoteProps {
  content: Quotes | QuoteType;
}

export interface Quotes {
  quotes?: { fields: QuoteType }[];
}

const NavigationalQuote = ({ content }: NavigationalQuoteProps) => {
  const { quotes } = content as Quotes;
  // Get only published quotes
  const publishedQuotes =
    quotes?.filter((quote) => quote.fields !== undefined) || [];

  const [longQuoteId, setLongQuoteId] = useState(0);
  const [showLightbox, setShowLightbox] = useState(false);

  const sliderSettings = {
    className: styles.carousel,
    allowTouchMove: true,
    loop: true,
    autoHeight: true,
    slidesPerView: 1,
    centeredSlides: true,
    pagination: { clickable: true },
    navigation: true,
    keyboard: { enabled: true, onlyInViewport: true },
    a11y: { enabled: true },
    modules: [Pagination, Navigation, Keyboard, A11y],
  };

  const onReadMoreClick = (clicked?: number) => {
    if (clicked !== undefined) {
      setLongQuoteId(clicked);
    }
    setShowLightbox(true);
  };

  const closeLightbox = () => {
    setTimeout(() => {
      setShowLightbox(false);
    }, 300);
  };

  if (!quotes || publishedQuotes.length === 0) {
    return <Quote content={content as QuoteType} />;
  }
  return (
    <div>
      {publishedQuotes &&
      publishedQuotes.length > 1 &&
      Slider &&
      SwiperSlide ? (
        <div className={styles["navigational-quote-carousel"]}>
          <Slider {...sliderSettings}>
            {publishedQuotes.map((quote, i) => (
              <SwiperSlide key={`${quote.fields?.quote}${i}`}>
                {({ isActive }) => (
                  <Quote
                    aria-hidden={!isActive}
                    // @ts-expect-error inter is not recognized by TS
                    inert={!isActive ? "true" : undefined}
                    quoteId={i}
                    content={{ ...quote.fields }}
                    onReadMoreClick={onReadMoreClick}
                  />
                )}
              </SwiperSlide>
            ))}
          </Slider>

          {showLightbox && (
            <QuoteModal
              authorJobTitle={
                publishedQuotes?.[longQuoteId].fields.authorJobTitle
              }
              authorName={publishedQuotes?.[longQuoteId].fields.authorName}
              shortQuote={publishedQuotes?.[longQuoteId].fields.quote}
              onClose={closeLightbox}
              longQuote={publishedQuotes[longQuoteId].fields.longQuote}
            ></QuoteModal>
          )}
        </div>
      ) : publishedQuotes[0].fields.fullWidth ? (
        <div className={styles["navigational-quote-carousel"]}>
          <Quote content={{ ...publishedQuotes[0].fields }} />
        </div>
      ) : (
        <Quote content={{ ...publishedQuotes[0].fields }} />
      )}
    </div>
  );
};

export default NavigationalQuote;
